if ($("#managerStream").length){
        $('#managerModelStream').addClass('current-page');
        $("#managerTableStream_allmodels").tablesorter();
}
